import { ModicaChip } from "@modica-library/chip/react";
import { Children, type ReactNode } from "react";

const CHIP_TYPE = { neutral: "grey", info: "blue", coin: "coin" } as const;

/** Thin wrapper over @modica-library/chip, used for the credits pill.
 *  Flattens children to a single label string (avoids the array `.toString()` comma). */
export function Chip({ children, tone = "neutral" }: { children: ReactNode; tone?: "neutral" | "info" | "coin" }) {
  const label = Children.toArray(children)
    .map((c) => (typeof c === "string" || typeof c === "number" ? String(c) : ""))
    .join("");
  return <ModicaChip chipType={CHIP_TYPE[tone]} label={label} />;
}
